import { TAccountType } from "@/api/v1_0";
import { FunctionComponent, ReactElement } from "react";
import { ITitleProps } from "./types";

export const Title: FunctionComponent<ITitleProps> = (
  props: ITitleProps
): ReactElement<ITitleProps> | null => {
  const { account } = props;

  switch (account.type) {
    case TAccountType.Debt:
      return (
        <div className="blockLine minLine">
          <h3>История платежей:</h3>
        </div>
      );

    case TAccountType.ExpenseCategory:
      return (
        <div className="blockLine minLine">
          <h3>История:</h3>
        </div>
      );

    case TAccountType.Goal:
      return (
        <div className="blockLine minLine">
          <h3>История цели:</h3>
        </div>
      );

    case TAccountType.IncomeSource:
      return (
        <div className="blockLine minLine">
          <h3>История:</h3>
        </div>
      );

    case TAccountType.Saving:
      return (
        <div className="blockLine minLine">
          <h3>История счета:</h3>
        </div>
      );

    default:
      return null;
  }
};
